import { ADD_SHARED_BANKS, REMOVE_SHARED_BANK, UPDATE_SHARED_BANK_PERMISSION } from '@instructure/quiz-common';
export var addSharedBanks = function addSharedBanks(sharedBank) {
  return {
    type: ADD_SHARED_BANKS,
    payload: sharedBank
  };
};
export var updateSharedBankPermission = function updateSharedBankPermission(sharedBankId, permission) {
  return {
    type: UPDATE_SHARED_BANK_PERMISSION,
    payload: {
      sharedBankId: sharedBankId,
      permission: permission
    }
  };
};
export var removeSharedBank = function removeSharedBank(sharedBankId) {
  return {
    type: REMOVE_SHARED_BANK,
    payload: sharedBankId
  };
};